import script from "./materialSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./materialSelect.vue?vue&type=script&setup=true&lang=js"

import "./materialSelect.vue?vue&type=style&index=0&id=58e7ecf4&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58e7ecf4"]])

export default __exports__